import apiClient from './client';

export interface Album {
  id: string;
  name: string;
  description: string | null;
  coverMediaId: string | null;
  previewMediaId: string | null;
  previewFilename: string | null;
  previewMimeType: string | null;
  mediaCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAlbumInput {
  name: string;
  description?: string | null;
  coverMediaId?: string | null;
}

export type UpdateAlbumInput = Partial<CreateAlbumInput>;

export async function fetchAlbums(): Promise<Album[]> {
  const { data } = await apiClient.get<Album[]>('/albums');
  return data;
}

export async function createAlbum(input: CreateAlbumInput): Promise<Album> {
  const { data } = await apiClient.post<Album>('/albums', input);
  return data;
}

export async function updateAlbum(id: string, input: UpdateAlbumInput): Promise<Album> {
  const { data } = await apiClient.patch<Album>(`/albums/${id}`, input);
  return data;
}

export async function deleteAlbum(id: string): Promise<void> {
  await apiClient.delete(`/albums/${id}`);
}
